module.exports = __webpack_public_path__ + "static/media/warning-red.1fd92c2e.svg";